var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPublisherPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99991 0H21.9997C23.1001 0 24 0.899943 24 1.99991V3.99982H0V1.99991C0 0.899943 0.899943 0 1.99991 0ZM24 6.00009V22.0001C24 23.0997 23.1001 24 21.9997 24H8V6.00009H24ZM6.00009 24H1.99991C0.900295 24 0 23.1001 0 22.0001V6.00009H6.00009V24Z",
    fill: "#C0C6CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublisherPanel);
export default __webpack_public_path__ + "static/media/icon_publisher_panel.f2cd1640f80e8c415807c74cf85e3e88.svg";
export { ForwardRef as ReactComponent };